(ns shared.core.components.auth0.views
  (:require [shared.core.reactive :as re]
            [shared.core.util :as util]
            [shared.core.config :as config]
            [shared.core.components.auth0.data :as auth0.d]
            [cljs.reader :refer [read-string]]
            ["@auth0/auth0-react" :as auth0-react]))

(defn auth0-wrapper [cmp-to-wrap props-to-cmp]
  (let [wrapped-cmp (re/create-class
                      {:reagent-render
                       (fn [props]
                         [cmp-to-wrap (-> (update props :auth0 #(-> % (js->clj) (util/->kebab-case-keywords)))
                                          (merge props-to-cmp))])})]
    [(re/adapt-react-class (auth0-react/withAuth0 wrapped-cmp))]))

(defn auth0-root-view [component props]
  (let [wp (util/window-url-params)]
    ;; If we want to support organization swapping, you can update `:authorizationParams` to include `organization` with
    ;; the organization ID that they want to switch to, as well as `prompt` value of `none`. Assuming these orgs have a
    ;; shared auth connection that was used to auth originally, the page should reload with the organization switched.
    [:> auth0-react/Auth0Provider {:domain config/AUTH0_DOMAIN
                                   :clientId config/AUTH0_CLIENT_ID
                                   :cacheLocation "localstorage"
                                   :onRedirectCallback (fn [app-state]
                                                         (when-let [target-route (some->> app-state
                                                                                          (util/js-obj->kebab-case-keywords)
                                                                                          :target-route
                                                                                          (read-string))]
                                                           (re/dispatch [:router/go target-route])))
                                   :authorizationParams (-> {:redirect-uri (.. js/window -location -origin)
                                                             :audience config/AUTH0_AUDIENCE
                                                             :scope config/AUTH0_SCOPE}
                                                            (merge (select-keys wp [:invitation :organization]))
                                                            (#(if (:invitation wp)
                                                                (merge {:screen-hint "signup"} %)
                                                                %))
                                                            (util/->snake_case_string))}
     [auth0-wrapper component props]]))
